import React, { useRef, useMemo, useCallback } from 'react'

const styles = {
  container: {
    display: 'flex',
    gap: '32px',
    flexWrap: 'wrap',
  },
  column: {
    flex: '1',
    minWidth: '300px',
  },
  cluesList: {
    maxHeight: '400px',
    overflowY: 'auto',
    border: '2px solid var(--color-border)',
    padding: '12px',
  },
  clueItem: {
    marginBottom: '12px',
    paddingBottom: '12px',
    borderBottom: '1px solid #ccc',
  },
  clueNumber: {
    fontWeight: '700',
    marginRight: '8px',
  },
  clueWord: {
    fontFamily: 'var(--font-mono)',
    background: 'var(--color-light)',
    padding: '2px 6px',
    marginLeft: '8px',
  },
  clueLength: {
    fontSize: '0.8rem',
    color: 'var(--color-muted)',
    marginLeft: '8px',
  },
  clueInput: {
    width: '100%',
    padding: '6px 8px',
    border: '1px solid var(--color-border)',
    marginTop: '4px',
    fontSize: '0.9rem',
  },
}

export default function CluesEditor({
  acrossEntries,
  downEntries,
  clues,
  onClueChange,
}) {
  const inputRefs = useRef({})

  // Create ordered list of input keys (across first, then down)
  const orderedInputKeys = useMemo(() => {
    const keys = []
    acrossEntries.forEach(entry => keys.push(`across-${entry.num}`))
    downEntries.forEach(entry => keys.push(`down-${entry.num}`))
    return keys
  }, [acrossEntries, downEntries])

  const handleKeyDown = useCallback((e, currentKey) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      const currentIdx = orderedInputKeys.indexOf(currentKey)
      if (currentIdx !== -1 && currentIdx < orderedInputKeys.length - 1) {
        const nextKey = orderedInputKeys[currentIdx + 1]
        inputRefs.current[nextKey]?.focus()
      }
    }
  }, [orderedInputKeys])

  return (
    <div style={styles.container}>
      <div style={styles.column}>
        <h3>Across</h3>
        <div style={styles.cluesList}>
          {acrossEntries.map(entry => (
            <div key={entry.num} style={styles.clueItem}>
              <div>
                <span style={styles.clueNumber}>{entry.num}.</span>
                <span style={styles.clueWord}>{entry.word}</span>
                <span style={styles.clueLength}>({entry.length} letters)</span>
              </div>
              <input
                type="text"
                ref={el => inputRefs.current[`across-${entry.num}`] = el}
                value={clues.across[entry.num] || ''}
                onChange={e => onClueChange('across', entry.num, e.target.value)}
                onKeyDown={e => handleKeyDown(e, `across-${entry.num}`)}
                placeholder="Enter clue..."
                style={styles.clueInput}
              />
            </div>
          ))}
        </div>
      </div>

      <div style={styles.column}>
        <h3>Down</h3>
        <div style={styles.cluesList}>
          {downEntries.map(entry => (
            <div key={entry.num} style={styles.clueItem}>
              <div>
                <span style={styles.clueNumber}>{entry.num}.</span>
                <span style={styles.clueWord}>{entry.word}</span>
                <span style={styles.clueLength}>({entry.length} letters)</span>
              </div>
              <input
                type="text"
                ref={el => inputRefs.current[`down-${entry.num}`] = el}
                value={clues.down[entry.num] || ''}
                onChange={e => onClueChange('down', entry.num, e.target.value)}
                onKeyDown={e => handleKeyDown(e, `down-${entry.num}`)}
                placeholder="Enter clue..."
                style={styles.clueInput}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
